import React__default, { useState } from 'react';
import { List, ListItemButton, ListItemIcon, ListItemText, Box, Collapse } from '@mui/material';
import clsx from 'clsx';
import StateDot from '../StateDot/index.js';

var KMenuWithChilds = function (_a) {
    var menu = _a.menu, expandMoreIcon = _a.expandMoreIcon, expandLessIcon = _a.expandLessIcon, onMenuClick = _a.onMenuClick;
    var _b = useState(true), open = _b[0], setOpen = _b[1];
    var handleOpen = function () {
        setOpen(!open);
    };
    return (React__default.createElement(Box, { role: "menuitem" },
        React__default.createElement(ListItemButton, { "data-testid": "Menu-".concat(menu.key), onClick: handleOpen },
            menu.icon && React__default.createElement(ListItemIcon, null, menu.icon),
            React__default.createElement(ListItemText, { primary: menu.label }),
            expandLessIcon !== undefined && expandMoreIcon !== undefined && open
                ? expandLessIcon
                : expandMoreIcon),
        React__default.createElement(Collapse, { "in": open, timeout: "auto", unmountOnExit: true },
            React__default.createElement(List, { role: "menu", component: "div", disablePadding: true }, menu.childs.map(function (child) {
                var _a;
                return (React__default.createElement(ListItemButton, { role: "menuitem", key: child.href, "data-testid": "Menu-".concat(child.key), onClick: function () {
                        onMenuClick(child.href);
                    }, sx: {
                        paddingLeft: function (theme) { return theme.spacing(12); },
                        backgroundColor: function (theme) {
                            return child.selected ? theme.palette.divider : "transparent";
                        },
                        position: "relative"
                    }, selected: child.selected },
                    child.isDotAppliable && (React__default.createElement(StateDot, { isFinalizedAdminState: (_a = child.isFinalizedState) === null || _a === void 0 ? void 0 : _a.isFinalize, sx: { position: "absolute", left: "20%", top: "calc(50% - 6px)" } })),
                    React__default.createElement(ListItemText, { primary: child.label })));
            })))));
};
var KMenu = function (_a) {
    var className = _a.className, menu = _a.menu, expandMoreIcon = _a.expandMoreIcon, expandLessIcon = _a.expandLessIcon, onMenuClick = _a.onMenuClick;
    return (React__default.createElement(List, { component: "div", role: "menu", className: clsx("KMenu", className) }, menu
        ? menu.map(function (menuItem) {
            return menuItem.hasChild ? (React__default.createElement(KMenuWithChilds, { key: menuItem.key, "data-testid": "MenuWithChild-".concat(menuItem.key), menu: menuItem, expandMoreIcon: expandMoreIcon, expandLessIcon: expandLessIcon, onMenuClick: onMenuClick })) : (React__default.createElement(ListItemButton, { key: menuItem.key, "data-testid": "Menu-".concat(menuItem.key), onClick: function () {
                    onMenuClick(menuItem.href);
                }, selected: menuItem.selected, role: "menuitem", sx: {
                    backgroundColor: function (theme) {
                        return menuItem.selected ? theme.palette.divider : "transparent";
                    }
                } },
                menuItem.icon && React__default.createElement(ListItemIcon, null, menuItem.icon),
                React__default.createElement(ListItemText, { primary: menuItem.label })));
        })
        : null));
};

export { KMenu as default };
//# sourceMappingURL=index.js.map
